module.exports = __webpack_public_path__ + "fonts/Roboto-500-latin-ext13.9165081.woff2";